import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import MetricaCompetenciaServices from "./metricaCompetencia_services";
import moment from "moment";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const resetMetricaCompetencias = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_METRICA_POR_COMPETENCIA,
      payload: true,
    });
    dispatch({
      type: actions.GET_METRICA_POR_COMPETENCIA,
      payload: {data:[],count:0}
    });
    dispatch({
      type: actions.METRICA_POR_COMPETENCIA_FALLA,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.METRICA_POR_COMPETENCIA_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_METRICA_POR_COMPETENCIA,
      payload: false,
    });
  }
}

export const getMetricaCompetencias = (filters, periods) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_METRICA_POR_COMPETENCIA,
      payload: true,
    });
    const resp = await MetricaCompetenciaServices.getMetricaCompetencias(filters);
   // const length = periods.length - 1;
   // const fecha = new Date();
    // console.clear();
     console.log('RESPONSE => ', resp.data);
    dispatch({
      type: actions.GET_METRICA_POR_COMPETENCIA,
      payload: resp.data, // agregar .data
    });
    const length = periods.length - 1;
    const fecha = new Date();
    dispatch({
      type: actions.GET_ULTIMO_REGISTRO,
      payload: resp.data.data[length] &&
      resp.data.data[length].fecha_fin &&
      moment(fecha) < moment(resp.data.data[length].fecha_fin)
        ? resp.data.data[length]
        :resp.data && resp.data.count > 0 ? resp.data.data[resp.data.count -1 ].grado : null,
    });
    dispatch({
      type: actions.METRICA_POR_COMPETENCIA_FALLA,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.METRICA_POR_COMPETENCIA_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_METRICA_POR_COMPETENCIA,
      payload: false,
    });
  }
}

export const saveMetricaCompetencias = (req, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_METRICA_POR_COMPETENCIA,
      payload: true,
    });
    const resp = await MetricaCompetenciaServices.saveMetricaCompetencias(req);
    const { data, count } = getState().metricaCompetencia.metricaCompetencia;
    dispatch({
      type: actions.GET_METRICA_POR_COMPETENCIA,
      payload: {
        count: count + 1,
        data: [...data, resp.data]
      },
    });
    dispatch({
      type: actions.FORM_METRICA_POR_COMPETENCIA_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_METRICA_POR_COMPETENCIA_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADER_METRICA_POR_COMPETENCIA,
      payload: false,
    });
  }
};

export const editMetricaCompetencias = (req, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_METRICA_POR_COMPETENCIA,
      payload: true,
    });
    const resp = await MetricaCompetenciaServices.editMetricaCompetencias(req.id, req);
    const { data, count } = getState().metricaCompetencia.metricaCompetencia;
    let _data = data.slice();
    _data[index] = resp.data;
    dispatch({
      type: actions.GET_METRICA_POR_COMPETENCIA,
      payload: {
        data: _data,
        count: count,
      },
    });
    dispatch({
      type: actions.FORM_METRICA_POR_COMPETENCIA_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });

  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.METRICA_POR_COMPETENCIA_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_METRICA_POR_COMPETENCIA,
      payload: false,
    });
  }
}

export const deleteMetricaCompetencias = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_METRICA_POR_COMPETENCIA,
      payload: true,
    });
    await MetricaCompetenciaServices.deleteMetricaCompetencias(id);
    const { data, count } = getState().metricaCompetencia.metricaCompetencia;
    let _data = data.slice();
    _data.splice(index, 1);
    dispatch({
      type: actions.GET_METRICA_POR_COMPETENCIA,
      payload: {
        data: _data,
        count: count - 1
      },
    });
    dispatch({
      type: actions.METRICA_POR_COMPETENCIA_FALLA,
      payload: '',
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.data&&ex.response.data[0]){
              message = ex.response.data[0];
            }else{
              message = ex.response.data.mensaje;
            }
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.LOADER_METRICA_POR_COMPETENCIA,
      payload: false,
    });
  }
}

export const getUltimoRegistro = filters => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_ULTIMO_REGISTRO,
      payload: true,
    });
    const resp = await MetricaCompetenciaServices.getMetricaCompetencias(filters);
    dispatch({
      type: actions.GET_ULTIMO_REGISTRO,
      payload: resp.data && resp.data.count > 0 ? resp.data.data[resp.data.count -1 ].grado : null,
    });
    dispatch({
      type: actions.METRICA_POR_COMPETENCIA_FALLA,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.METRICA_POR_COMPETENCIA_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_ULTIMO_REGISTRO,
      payload: false,
    });
  }
}

